<template>
    <v-autocomplete
        ref="searchRef"
        v-model="cityId"
        :items="cities"
        item-title="name"
        item-value="id"
        :loading="isLoading"
        hide-no-data
        :label="label"
        clearable
        :rules="rules"
        :disabled="disabled"
        :hide-details="hideDetails"
        :density="dense ? 'compact' : 'comfortable'"
        @update:search="onSearch"
        @focus="searchRef.reset()"
        @blur="updateForm"
    >
        <template v-slot:item="{item, props}">
            <v-list-item v-bind="props">
                <template v-slot:title>
                    {{ `${item.raw.name}, ${item.raw.parentName}` }}
                </template>
            </v-list-item>
        </template>
        <template v-slot:selection="{item}">
            {{ `${item.raw.name}, ${item.raw.parentName}` }}
        </template>
    </v-autocomplete>
</template>

<script setup lang="ts">
    const props = defineProps<{
        productType?: string
        label?: string
        rules?: any[]
        disabled?: boolean
        hideDetails?: boolean
        dense?: string
    }>()

    const cities = ref([])
    const isLoading = ref<boolean>(false)
    const search = ref<string>(null)
    const timer = ref(null)
    const searchRef = ref()

    const cityId = defineModel<string>()

    const app = useNuxtApp()

    onMounted(async () => {
        if (cityId.value) await loadCities({id: cityId.value})
    })

    async function loadCities(rq) {
        try {
            isLoading.value = true
            const res = await app.$api.locations.get(rq)
            cities.value = res.cities
        } catch (e) {
            cities.value = []
        } finally {
            isLoading.value = false
        }
    }

    const updateForm = () => {
        if (!cities.value?.length) searchRef.value.reset()
    }

    const onSearch = val => {
        if (!val) return
        search.value = val

        if (search.value) {
            if (timer.value) {
                clearTimeout(timer.value)
            }

            timer.value = window.setTimeout(() => {
                loadCities({
                    limitCities: -1,
                    orderBy: 'POPULARITY',
                    ...(props.productType && {productType: props.productType}),
                    pattern: search.value,
                })
            }, 400)
        }
    }
</script>
